import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const pointerMQ = window.matchMedia('(pointer: coarse)');
const breakpointMQ = window.matchMedia(`(width <= ${breakpoints.sm}px)`);
const motionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

let observer;

function getOptions() {
  return breakpointMQ.matches
    ? { rootMargin: '0px 0px -80% 0px' }
    : { rootMargin: '0px 0px -50% 0px' };
}

function createObserver() {
  return new IntersectionObserver(async (entries) => {
    const entry = entries[0];
    const { target } = entry;

    if (entry.isIntersecting) {
      observer.unobserve(target);

      const images = target.querySelectorAll('img');

      const eventPromises = [...images].map((img) => new Promise((resolve) => {
        const boundCallback = function (e) {
          if (e.target === img) {
            img.removeEventListener('transitionend', boundCallback);
            resolve();
          }
        };

        if (img) {
          img.addEventListener('transitionend', boundCallback);
        } else {
          resolve();
        }
      }));

      target.dataset.animation = 'run';

      try {
        if (eventPromises.length > 0) {
          await Promise.all(eventPromises);
        }

        target.removeAttribute('data-animation');
      } catch (error) {
        console.error(error);
        target.removeAttribute('data-animation');
      }
    }
  }, getOptions());
}

function setWidthVariable(element) {
  element.style.setProperty('--browser-width', window.innerWidth);
}

function onGalleryClick(event) {
  const targetImage = event.target.closest('img');

  if (!targetImage) {
    return;
  }

  event.currentTarget.querySelectorAll('img').forEach((image) => {
    if (image === targetImage) {
      image.classList.toggle('hover');
    } else {
      image.classList.remove('hover');
    }
  });
}

function addMobileListeners(gallery) {
  if (pointerMQ.matches) {
    gallery.addEventListener('click', onGalleryClick);
  } else {
    gallery.removeEventListener('click', onGalleryClick);
    gallery.querySelectorAll('img').forEach((image) => {
      image.classList.remove('hover');
    });
  }
}

function initMediaGalleryAnimation(rootEl) {
  if (!rootEl) {
    return;
  }

  const gallery = rootEl.querySelector('.c-media-gallery-animation__gallery');

  if (!motionMQ.matches) {
    gallery.setAttribute('data-animation', 'pre');
    breakpointMQ.addEventListener('change', () => {
      if (observer) {
        observer.unobserve(gallery);
      }

      observer = createObserver();
      observer.observe(gallery);
    });

    observer = createObserver();
    observer.observe(gallery);
  }

  pointerMQ.addEventListener('change', () => {
    addMobileListeners(gallery);
  });

  window.addEventListener('resize', setWidthVariable.bind(null, rootEl));
  setWidthVariable(rootEl);

  addMobileListeners(gallery);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-media-gallery-animation', () => {
      document.querySelectorAll('.c-media-gallery-animation').forEach((el) => initMediaGalleryAnimation(el));
    });
  } else {
    document.querySelectorAll('.c-media-gallery-animation').forEach((el) => initMediaGalleryAnimation(el));
  }
});
